function createHyperBarChart(title, labels, colors) {
  var options = {
    title: {
      text: title,
      style: {
        fontSize:  '16px',
      },
    },
    chart: {
      height: 320,
      type: 'bar',
      animations: {
        enabled: false
      }
    },
    series: [],
    labels: labels.split(","),
    plotOptions: {
      bar: {
        horizontal: true,
        dataLabels: {
          position: 'bottom'
        },
      }
    },
    xaxis: {
      labels: {
        style: {
          fontSize: '14px',
        },
        formatter: function (value) {
          return value.toFixed(0);
        }
      },
      tickAmount: 1,
    },
    yaxis: {
      labels: {
        style: {
          fontSize: '14px',
        },
      },
    },
    legend: {
      show: true,
      position: 'bottom',
      horizontalAlign: 'center',
      verticalAlign: 'middle',
      floating: false,
      fontSize: '14px',
      offsetX: 0,
      offsetY: 7
    },
  }
  if (colors) {
    options.colors = colors.split(",");
  }
  return options;
}

function createHyperStackedBarChart(title, labels, colors) {
  var barChart = createHyperBarChart(title, labels, colors);
  barChart.chart.stacked = true;
  return barChart;
}

function addSeries(options, name, data) {
  var newSeries = options.series.concat([{
    name: name,
    data: data.split(",").map(function(num) { return parseInt(num, 10); })
  }]);
  options.series = newSeries;
  return options;
}

function renderChart(element, options) {
  var chart = new ApexCharts(element, options);
  chart.render();
}
